export default "__VITE_ASSET__df887c51__"